import React from 'react';

interface SearchComponentProps {
    queryKey: string;
    onSearch: (value: string) => void;
}

const SearchComponent: React.FC<SearchComponentProps> = ({ queryKey, onSearch }) => {
    return (
        <div className="search-component">
            <input
                type="text"
                className="form-control"
                placeholder="Search inventory categories..."
                value={queryKey}
                onChange={(e) => onSearch(e.target.value)}
                style={{ fontSize: '14px', height: '38px' }}
            />
        </div>
    );
};

export default SearchComponent;
